import React, { useState } from 'react';
import { ArrowUpRightIcon, ExternalLinkIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { BONUS_IMAGES } from '../data/images';
import { toThumb, toView } from '../data/links';
import { SectionHeading } from './SectionHeading';
const pad = (value: number) => String(value).padStart(2, '0');
export function BonusStack() {
  /* An image host we do not own can stop answering. If one does, that card
     quietly falls back to the typeset panel instead of a broken image. */
  const [broken, setBroken] = useState<Record<string, boolean>>({});
  return <section aria-labelledby="bonus-heading" id="bonus" className="scroll-mt-24" data-id="element-56" data-mp="3f1d14fm17usi">
      <SectionHeading index="04" title="Your eight bonuses" note="None of these are printed in the twelve books. They came with your order and they do not expire." data-id="element-57" data-mp="3jslaxcr9xi67">
        <span className="inline-flex items-center gap-1.5 border border-green/50 bg-green/[0.09] px-2.5 py-1 font-sans text-[10px] font-semibold tracking-[0.14em] text-green" data-id="element-58" data-mp="2rcajv8vb83yj">
          ALL UNLOCKED
        </span>
      </SectionHeading>

      <div className="mt-8 grid gap-px bg-rule sm:grid-cols-2 lg:grid-cols-3" data-id="element-59" data-mp="3ncrsz5y3wmn4">
        {bonuses.map(bonus => {
        const href = bonus.own ? toView(bonus.href) : bonus.href;
        const key = bonus.img;
        const source = BONUS_IMAGES[key] || (bonus.own ? toThumb(bonus.href, 480) : '');
        const img = broken[key] ? '' : source;
        return <article key={bonus.n} className="flex flex-col bg-surface" data-id="element-60" data-mp="34lh4evfuslye">
              {img ? <img src={img} alt="" aria-hidden="true" loading="lazy" onError={() => setBroken(prev => ({
            ...prev,
            [key]: true
          }))} className="aspect-[3/2] w-full bg-[#1F3A5F] object-cover" data-id="element-61" data-mp="2zlw4ahoy67k3" /> : <div aria-hidden="true" className="flex aspect-[3/2] w-full items-end justify-between bg-[#1F3A5F] p-5" data-id="element-62" data-mp="swzmox5xjuy7">
                  <span className="font-display text-[52px] font-semibold leading-none text-gold" data-id="element-63" data-mp="2s2v8kike1i7a">
                    {pad(bonus.n)}
                  </span>
                  <span className="pb-1 font-sans text-[10px] font-semibold uppercase tracking-[0.16em] text-[#F6F1E4]/55" data-id="element-64" data-mp="2dbw67pa5bpw5">
                    Bonus
                  </span>
                </div>}
              <div className="flex flex-1 flex-col p-6" data-id="element-65" data-mp="3b1h9nxfwn9b7">
                <div className="flex items-baseline justify-between gap-3" data-id="element-66" data-mp="3b0z7ylah42vw">
                  <p className="tnum font-display text-[11px] font-semibold tracking-[0.16em] text-gold" data-id="element-67" data-mp="2w36tzxkkrmjt">
                    BONUS {pad(bonus.n)}
                  </p>
                  <p className="tnum font-sans text-[11px] text-muted" data-id="element-68" data-mp="1kpbegnprdbs2">{bonus.volume}</p>
                </div>

                <h3 className="mt-3 font-display text-[19px] font-semibold leading-tight text-ink" data-id="element-69" data-mp="1poo0x7cpwgu4">
                  {bonus.title}
                </h3>
                <p className="mt-2 font-sans text-[14.5px] leading-relaxed text-ink/70" data-id="element-70" data-mp="7oorgtw33qkb">
                  {bonus.blurb}
                </p>

                <div className="mt-auto pt-6" data-id="element-71" data-mp="grpv8nxh95kt">
                  {href ? <a href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-green px-3.5 py-2.5 font-sans text-[13px] leading-none text-onaccent transition-colors duration-150 ease-out hover:bg-[#33684D] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface" data-id="element-72" data-mp="cpmhfsnc5owd">
                      {bonus.own ? <ExternalLinkIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} data-id="element-73" data-mp="31gx071ilien4" /> : <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} data-id="element-74" data-mp="2xf23kabm0pfo" />}
                      {bonus.own ? 'Open bonus' : 'Open pack'}
                    </a> : <span className="inline-flex items-center gap-2 border border-rule px-3.5 py-2.5 font-sans text-[13px] leading-none text-ink/30" data-id="element-75" data-mp="3f1t3l8qvg25o">
                      Link not set
                    </span>}
                </div>
              </div>
            </article>;
      })}
      </div>
    </section>;
}